/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @enum {string}
 */

export const AttendanceTypeEnum = {
  HERE: "H",
  ABSENT: "A",
  EXCUSED: "E",
} as const;

export type AttendanceTypeEnum =
  (typeof AttendanceTypeEnum)[keyof typeof AttendanceTypeEnum];

export type AttendanceTypeEnumEnumType = typeof AttendanceTypeEnum;
export type AttendanceTypeEnumOptional = AttendanceTypeEnum;
export type AttendanceTypeEnumTrackedI = AttendanceTypeEnum;
export type AttendanceTypeEnumTracked = AttendanceTypeEnum;
export type AttendanceTypeEnumMetaI = EnumMetaType<
  AttendanceTypeEnumEnumType,
  AttendanceTypeEnum
>;
export const AttendanceTypeEnumMeta = typeMetaEnum<
  AttendanceTypeEnumEnumType,
  AttendanceTypeEnum
>("AttendanceTypeEnum", AttendanceTypeEnum);
export function transformDatesAttendanceTypeEnum(model: AttendanceTypeEnum) {}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
